export const ENQUIRY_TYPES = {
  aircraft: {
    title: "Aircraft enquiry",
    overline: "Acquisition & Brokerage",
    intro: "Tell us what you are looking to buy or sell and a broker will come back with a discreet, considered response.",
    image: "https://images.unsplash.com/photo-1684838200815-36eef38f353c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    fields: [
      { key: "intent", label: "I want to", type: "select", options: ["Buy an aircraft", "Sell an aircraft"], required: true },
      { key: "model", label: "Aircraft type or model", placeholder: "e.g. Gulfstream G650, midsize jet", required: true },
      { key: "budget", label: "Budget or asking price", placeholder: "e.g. USD 25-30m" },
      { key: "year_range", label: "Year range", placeholder: "e.g. 2015 - 2020" },
      { key: "location", label: "Home base / location", placeholder: "e.g. London, Geneva" },
      { key: "timeframe", label: "Timeframe", type: "select", options: ["Immediately", "Within 3 months", "3-6 months", "Exploring options"] },
    ],
  },
  yacht: {
    title: "Yacht enquiry",
    overline: "Yacht Brokerage",
    intro: "Charter, purchase or sale - share the essentials and we will source through our brokerage network.",
    image: "https://images.unsplash.com/photo-1617905876311-5c4cad20de42?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    fields: [
      { key: "intent", label: "I want to", type: "select", options: ["Charter a yacht", "Buy a yacht", "Sell a yacht"], required: true },
      { key: "length", label: "Length range", placeholder: "e.g. 30-40 m" },
      { key: "region", label: "Region", placeholder: "e.g. Western Mediterranean, Caribbean" },
      { key: "dates", label: "Dates (charter)", placeholder: "e.g. 10-17 August" },
      { key: "budget", label: "Budget or asking price", placeholder: "e.g. EUR 150k / week or EUR 12m" },
      { key: "guests", label: "Guests", placeholder: "e.g. 10" },
    ],
  },
  bullion: {
    title: "Bullion & commodities enquiry",
    overline: "Tangible Assets",
    intro: "Physical gold, silver and selected commodities. Tell us the metal, direction and size and we will respond discreetly.",
    image: "https://images.unsplash.com/photo-1761437855740-c894da924d79?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    fields: [
      { key: "metal", label: "Metal / commodity", type: "select", options: ["Gold", "Silver", "Platinum", "Other"], required: true },
      { key: "intent", label: "I want to", type: "select", options: ["Buy", "Sell"], required: true },
      { key: "quantity", label: "Approximate quantity or value", placeholder: "e.g. 5 kg or GBP 250k", required: true },
      { key: "location", label: "Delivery or storage location", placeholder: "e.g. London vault, Zurich" },
    ],
  },
  charter: {
    title: "Request a flight",
    overline: "On-Demand Charter",
    intro: "One request, one dedicated broker. We source across our operator network and confirm aircraft and pricing with you.",
    image: "https://images.unsplash.com/photo-1661954864180-e61dea14208a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    fields: [
      { key: "trip_type", label: "Trip", type: "select", options: ["One-way", "Return", "Multi-leg"], required: true },
      { key: "passengers", label: "Passengers", type: "number", placeholder: "e.g. 8", required: true },
      { key: "departure", label: "Departure", placeholder: "e.g. London Farnborough", required: true },
      { key: "arrival", label: "Arrival", placeholder: "e.g. Dubai", required: true },
      { key: "date", label: "Date", placeholder: "e.g. 2 November or flexible", required: true },
      { key: "time", label: "Time", placeholder: "e.g. 09:00 or flexible" },
      { key: "aircraft_class", label: "Preferred aircraft class", type: "select", options: ["No preference", "Light jet", "Midsize", "Super-midsize", "Heavy jet", "Ultra-long-range", "Turboprop / helicopter"] },
      { key: "budget", label: "Budget range", placeholder: "e.g. GBP 20-30k" },
    ],
  },
};

ENQUIRY_TYPES.membership = {
  title: "Apply for membership",
  overline: "Aero Vista Club",
  intro: "Membership is by application. Tell us a little about how you travel and invest and Marcelle will come back personally with terms.",
  image: "https://images.unsplash.com/photo-1474302770737-173ee21bab63?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  fields: [
    { key: "interests", label: "Primarily interested in", type: "select", options: ["Private charter", "Aircraft purchase or sale", "Yachts", "Bullion & commodities", "Vistacoin / digital assets", "All of the above"], required: true },
    { key: "frequency", label: "How often do you fly privately?", type: "select", options: ["Several times a month", "Monthly", "A few times a year", "Not yet - exploring"] },
    { key: "location", label: "Home base", placeholder: "e.g. London, Dubai" },
    { key: "company", label: "Company / family office (optional)", placeholder: "Optional" },
  ],
};

export const ENQUIRY_LINKS = [
  { type: "charter", label: "Request a Flight" },
  { type: "aircraft", label: "Aircraft Enquiry" },
  { type: "yacht", label: "Yacht Enquiry" },
  { type: "bullion", label: "Bullion Enquiry" },
];
